import { NavigationMenuConstant } from '@/modules/Home/NavigationMenu/NavigationMenuConstant';

/** Sections a participant has no data for. */
export const PARTICIPANT_HIDDEN_NAV_SECTIONS = [NavigationMenuConstant.design];

/** Avatar menu cards shown in the mobile and tablet bottom sheet. */
export const PARTICIPANT_MOBILE_PROFILE_KEYS = ['recent', 'order', 'account', 'log-out'] as const;

/** Cards shown in the home orders strip before the rest move behind "See All". */
export const PARTICIPANT_ORDERS_STRIP_LIMIT = 10;

export const PARTICIPANT_PORTAL_COPY = {
  MY_ACCOUNT_TITLE: 'My Account',
  SEE_ALL_ORDERS: 'See All Orders',
  LOADING_ALL_ORDERS: 'Loading Orders...',
  YOU_HEADING: 'You',
  FULL_NAME_LABEL: 'Full Name',
  EMAIL_LABEL: 'Email',
  PHONE_LABEL: 'Phone',
  SIGN_OUT: 'Sign Out',
  LOADING_SESSION: 'Checking your session...',
  LOADING_PORTAL: 'Setting up your portal...',
  LOADING_ORDERS: 'Loading your orders...',
  LOADING_ORDER: 'Loading order details...',
  EMPTY_ORDERS: 'No orders found for this email yet.',
  ORDER_NOT_FOUND: "We couldn't find that order.",
} as const;
